import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MxFormModule, MxMaterialModule} from 'mx-core';
import {PrlActiveAccountComponent} from "./prl-active-account/prl-active-account.component";
import {PrlChangePasswordDialogComponent} from './prl-change-password-dialog/prl-change-password-dialog.component';
import {PrlLanguageModule} from '../prl-language/prl-language.module';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MxMaterialModule,
        MxFormModule,
        PrlLanguageModule
    ],
    exports: [
        PrlActiveAccountComponent
    ],
    declarations: [PrlActiveAccountComponent, PrlChangePasswordDialogComponent]
})
export class PrlToolbarModule {
}
